import { IDailySnapshot } from "../../@types/Dashboard/IDailySnapshot";
import i18n from "../../i18n";

export function dailySnapshotEvaluation(snapshot: IDailySnapshot) {
  const names = Array.from(new Set((snapshot.fodders ?? [])
    .map(fodder => [fodder.genus, fodder.species].filter(Boolean).join(" ").trim())
    .filter(Boolean)));
  const levels: Record<string, string> = {
    "MUITO ALTO": "veryHigh", "ALTO": "high", "MÉDIO": "medium",
    "BAIXO": "low", "MUITO BAIXO": "veryLow",
  };
  const fertility = snapshot.fertility_level?.trim();
  const level = fertility && levels[fertility.toUpperCase()];
  return {
    fodders: names.length ? names.join("; ") : "",
    fertility: level ? i18n.t(`dailySnapshotEvaluation.levels.${level}`)
      : fertility || "",
  };
}
